export const REGISTER_URL = "https://wordcripto.com/?ref=GianniSarti";
export const REFERRAL_CODE = "GianniSarti";
